import './Footer.scss'
import {Link} from 'react-router-dom'
import {HashLink} from 'react-router-hash-link'
import config from '../../config'
import logo from '../../assets/logo.svg'

export const Footer = () => {
    return (
        <footer className="footer">
            <div className={'inner-footer-wrapper'}>
                <div className={'footer-info'}>
                    <HashLink className={'link'} to={config.root + '/#home'}>
                        <img  height={32} width={32} src={logo} alt={'Feedback Logo'}/>
                        UXForm
                    </HashLink>
                    <p className={'text'}>
                        Simplify collecting user feedback.<br/>
                        Gather it at critical points.<br/>
                        Gain valuable insights.<br/>
                        Drive business growth.
                    </p>
                    <p className={'copyright-text'}>Copyright © {new Date().getFullYear()}</p>
                </div>
                <div className={'footer-links'}>
                    <div className={'footer-link-list'}>
                        <label>Links</label>
                        <HashLink className={"link"} to={config.root + '/#home'}>Homepage</HashLink>
                        <Link className={"link"} to={config.root + '/docs'}>Docs</Link>
                        <Link className={"link"} to={config.root + '/forms'}>Forms</Link>
                        <Link className={"link"} to={config.root + '/settings'}>Settings</Link>
                    </div>
                    <div className={'footer-link-list'}>
                        <label>Legal</label>
                        <Link className={"link"} to={config.root + '/terms-of-service'}>Terms of services</Link>
                        <Link className={"link"} to={config.root + '/privacy-policy'}>Privacy policy</Link>
                    </div>
                    <div className={'footer-link-list'}>
                        <label>Support</label>
                        <Link className={"link"} to={`mailto:${config.contactEmail}`}>Contact us</Link>
                        <button className={'feedback-btn'}>⭐️ Give us feedback</button>
                    </div>
                </div>
            </div>
        </footer>
    )
}